<section>
    <h2>Student</h2>
    <app-vcl-filter [pageId]="pageId" [userInfos]="userInfos" [modes]="modes" (filterDataOutputEvent)="loadStudentData($event)">
    </app-vcl-filter>
    <app-student-manager [userInfos]="userInfos" [data]="dataSource" [platformInfos]="platformInfos" (inProgress)="setProgress($event)"></app-student-manager>
</section>
